export default __webpack_public_path__ + "9f57e7d4017ef9b93ae75e2c86f00d60.ttf";